import React from "react";

import Overlay from "./Overlay";
import Modal from "./Modal";
import Iframe from "./Iframe";

import config from "config";

export default function Integration({
  partner,
  language,
  flow,
  snr,
  gid,
  siteType,
  env,
}) {
  let src = `${config.integrationUrl}${language}/login?partner=${partner}`;
  let modalSize = "modal-small";
  if (flow === "registration") {
    src = `${config.integrationUrl}${language}?partner=${partner}`;
    modalSize = "modal-large";
  }

  if (flow === "customer_login") {
    src = `${config.integrationUrl}${language}/customer?partner=${partner}`;
    modalSize = "modal-large";
  }
  if (flow === "smart_check_in") {
    const params = new URLSearchParams({
      partner,
      snr,
      gid,
      siteType,
      env,
    }).toString();
    src = `${config.integrationUrl}${language}/smartCheckIn?${params}`;
    modalSize = "modal-large";
  }

  return (
    <Overlay>
      <Modal size={modalSize}>
        <Iframe src={src} />
      </Modal>
    </Overlay>
  );
}
